import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { alpha, Paper, Stack, ThemeProvider, useTheme } from '@mui/material';
import { useState } from 'react';
import { smallerInputTheme } from '../../../cosmetics/Themes/MuiInputSmaller';
import { GeofenceMetricsTable } from './CoverageTable';
const debug = process.env.REACT_APP_DEBUG && false;
export const AreaDataPopup = ({ vob }) => {
    debug && console.log('AreaDataPopup has vob', vob);
    const theme = useTheme();
    const [expanded, setExpanded] = useState(false);
    let content = _jsx(_Fragment, { children: vob.data ? (vob.name ?? 'Unnamed') : 'No metrics' });
    if (expanded && vob.data)
        content = _jsx(GeofenceMetricsTable, { geofenceMetrics: (vob.data.receptionStats ?? vob.data) });
    return (_jsx(Paper, { onMouseEnter: () => {
            setExpanded(true);
        }, onMouseLeave: () => {
            setExpanded(false);
        }, sx: {
            width: vob?.name ? undefined : 400,
            maxWidth: 400,
            position: 'inherit',
            transform: 'translateX(-50%) translateY(-25%)',
            backgroundColor: alpha(theme.palette.background.paper, 0.6),
            backdropFilter: 'brightness(110%) blur(0.75em)',
            [`:hover`]: { zIndex: 10, boxShadow: (t) => t.shadows[5] },
        }, children: _jsx(ThemeProvider, { theme: smallerInputTheme, children: _jsx(Stack, { paddingBlock: 0.25, paddingInline: 0.75, gap: 1, sx: { ['& > :last-child:not(:first-child)']: { marginBlockEnd: 0.75 } }, children: content }) }) }, `areaData_${vob.sk}`));
};
